export const capitalizeFirstLetter = (stringToCapitalize) => {
    if (!stringToCapitalize)
        return "";
    return stringToCapitalize.charAt(0).toUpperCase() + stringToCapitalize.slice(1);
};
